import {ValueOf} from "../../../utils/typescript/ValueOf";

export const formControlTypes = {
    input: 'input',
    textarea: 'textarea',
    select: 'select',
    radio: 'radio',
    checkbox: 'checkbox',
    checkboxSingle: 'checkboxSingle',
    range: 'range',
    color: 'color'
} as const


export type formControlValueType = ValueOf<typeof formControlTypes>
